import { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import RwDateTimePicker from 'react-widgets/lib/DateTimePicker';
import 'react-widgets/lib/scss/react-widgets.scss';

import { getTimezoneOffset } from 'common/selectors/index';
import { DATE_TIME } from 'common/util/dateTime';

momentLocalizer(moment);

class DateOnlyPicker extends Component {
    focus() {
        this.element.focus();
    }

    getFormat() {
        return DATE_TIME.DATE_ONLY_FORMAT;
    }

    getPlaceholder() {
        return DATE_TIME.DATE_ONLY_PLACEHOLDER;
    }

    render() {
        const { value } = this.props;
        return (
            <RwDateTimePicker ref={e => this.element = e}
                {...this.props}
                value={value ? value.toDate() : null}
                format={this.getFormat()}
                placeholder={this.getPlaceholder()}
                data-cy="DateOnlyPicker-RwDateTimePicker"
            />
        );
    }
}

export default connect((state, props) => {
    return {
        timezoneOffset: getTimezoneOffset(state),
    };
}, {

})(DateOnlyPicker);


// DOCS http://jquense.github.io/react-widgets/docs/#/datetime-picker
DateOnlyPicker.propTypes = RwDateTimePicker.propTypes;

// export default DateOnlyPicker;
